<template>
  <div>
    <JobRoundDisplay
      v-for="round in rounds"
      :key="round.id"
      :round="round"
      :week_index="selected_week_index"
      :day_index="day_index"
      :editable="false"
      :schedule_index="schedule_index"
    />
  </div>
</template>

<script>
import JobRoundDisplay from "@/components/job/JobRoundDisplay.vue";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "CombinedJobDayDisplay",
  props: {
    day_index: {
      type: Number,
      required: true,
    },
    schedule_index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isDragging: false,
    delayedDragging: false,
    rounds: [],
  }),
  computed: {
    ...mapState("schedule", [
      "schedule_group_weeks",
      "schedule_rounds",
      "selected_week",
      "selected_week_index",
      "schedules",
      "changes",
    ]),
    ...mapState("status", ["job_dragging_enabled"]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: true,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    this._reload();
  },
  watch: {
    changes: {
      deep: true,
      handler() {
        this._reload();
      },
    },
    schedule_group_weeks: {
      deep: true,
      handler() {
        this._reload();
      },
    },
    selected_week(new_value) {
      var schedule = this.schedule_group_weeks[this.schedule_index];
      var date = moment(this.schedules[this.schedule_index].date)
        .add(new_value * 7 + this.day_index, "days")
        .format("yyyy-MM-DD");
      var result =
        schedule[new_value % schedule.length].days[this.day_index].rounds;

      // remove changes
      result = result.filter(
        x =>
          x.changes.filter(
            y => moment(y.from_date).format("yyyy-MM-DD") == date,
          ).length == 0,
      );

      // add changes
      if (this.schedule_index == 0) {
        var today_changes = this.changes.filter(
          x => moment(x.to_date).format("yyyy-MM-DD") == date,
        );
        today_changes.forEach(element => {
          this.schedule_rounds.forEach(rd => {
            if (rd.id == element.schedule_round_id) {
              result.push(rd);
            }
          });
        });
      }
      this.rounds = result;
    },
    day_index(new_value) {
      var schedule = this.schedule_group_weeks[this.schedule_index];
      var result =
        schedule[this.selected_week_index % schedule.length].days[new_value]
          .rounds;

      var date = moment(this.schedules[this.schedule_index].date)
        .add(this.selected_week * 7 + new_value, "days")
        .format("yyyy-MM-DD");

      // remove changes
      result = result.filter(
        x =>
          x.changes.filter(
            y => moment(y.from_date).format("yyyy-MM-DD") == date,
          ).length == 0,
      );

      // add changes
      if (this.schedule_index == 0) {
        var today_changes = this.changes.filter(
          x => moment(x.to_date).format("yyyy-MM-DD") == date,
        );
        today_changes.forEach(element => {
          this.schedule_rounds.forEach(rd => {
            if (rd.id == element.schedule_round_id) {
              result.push(rd);
            }
          });
        });
      }
      this.rounds = result;
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    _reload() {
      this.$nextTick(() => {
        var schedule = this.schedule_group_weeks[this.schedule_index];
        var result =
          schedule[this.selected_week_index % schedule.length].days[
            this.day_index
          ].rounds;

        var date = moment(this.schedules[this.schedule_index].date)
          .add(this.selected_week * 7 + this.day_index, "days")
          .format("yyyy-MM-DD");

        // remove changes
        result = result.filter(
          x =>
            x.changes.filter(
              y => moment(y.from_date).format("yyyy-MM-DD") == date,
            ).length == 0,
        );

        // add changes
        if (this.schedule_index == 0) {
          var today_changes = this.changes.filter(
            x => moment(x.to_date).format("yyyy-MM-DD") == date,
          );
          today_changes.forEach(element => {
            this.schedule_rounds.forEach(rd => {
              if (rd.id == element.schedule_round_id) {
                result.push(rd);
              }
            });
          });
        }

        this.rounds = result;
      });
    },
    moment(arg) {
      return moment(arg);
    },
  },
  components: {
    JobRoundDisplay,
  },
};
</script>
